import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_uq6uf6uvrw: FaireBrandEntity = {
  token: "b_uq6uf6uvrw",
  type: "brand",
  name: "Jay Jools",
  avatarUrl:
    "https://cdn.faire.com/fastly/9c5d827a0c0cf8207f98bb6e8122ac2dab87e87a0732dc933f95786ff9437974.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4be90c5a423d3587fa6f4200d595f94001b8e1ee375c2880ae5f4bc731b8a528.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9c5d827a0c0cf8207f98bb6e8122ac2dab87e87a0732dc933f95786ff9437974.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4be90c5a423d3587fa6f4200d595f94001b8e1ee375c2880ae5f4bc731b8a528.jpeg",
  location: "Tucson, AZ, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 4,
  isInsider: true,
  description:
    "Jay Jools – Crafted with Passion in Tucson, Arizona\nJay Jools is a dedicated jewelry manufacturing unit based in Tucson, Arizona, proudly employing a team of over 20 skilled artisans, designers, and craftsmen. Specializing in handcrafted fine jewelry, we blend traditional techniques with modern design to create high-quality rings, earrings, necklaces, and custom pieces. Located in the heart of the gemstone capital, we draw inspiration from Tucson’s rich gem and mineral culture, sourcing premium gemstones and materials from trusted suppliers.\nOur commitment to excellence is reflected in every stage—from CAD design and casting to polishing and setting. At Jay Jools, we focus on precision, beauty, and durability, ensuring each piece meets the highest standards. Whether producing for retailers, private labels, or custom clients, we deliver reliable, USA-based jewelry manufacturing with heart.\nJay Jools is where passion, craftsmanship, and innovation come together to create jewelry that lasts a lifetime. Made in Tucson. Worn worldwide.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:56.692Z",
    importedBy: "entity-db-cli",
  },
};
